import script from "./PaymentMethods.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethods.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethods.vue?vue&type=style&index=0&id=97444d82&scoped=true&lang=css"

import exportComponent from "/home/berisalam-console/webapps/berisalam-console/releases/1793606032384/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97444d82"]])

export default __exports__